var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickupTambo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFEF00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5747 5.30005H14.0148L15.557 10.9552H16.3943L17.9853 5.30005H21.3835L27.7334 27.223L26.7216 28.2334H20.7206L19.4855 23.8648H18.4737L17.4131 28.2334H14.7196L13.3519 23.8648H12.5146L11.3214 28.2334H5.27852L4.26672 27.223L10.5747 5.30005Z",
    fill: "#681381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupTambo);
export default __webpack_public_path__ + "static/media/pickup-tambo.bf37790c20fea021f7091156b791c6d8.svg";
export { ForwardRef as ReactComponent };